import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
// NOTE: React.StrictMode is intentionally omitted. FullCalendar v5 (used on
// /schedule) is not React-18-StrictMode compatible — Strict's dev-only double
// invocation of layout effects makes FullCalendar's TableRow.updateSizing →
// setState cycle never settle, throwing "Maximum update depth exceeded" on the
// calendar (especially on month navigation). StrictMode is a dev-only aid and
// has no effect on production builds, so removing it changes nothing in prod.
// Long-term fix: upgrade @fullcalendar/* to v6 (React 18 compatible) and
// restore StrictMode.
root.render(<App />);
